/* ------------------------- External Dependencies -------------------------- */
import { Avatar } from 'particles'
export default Avatar



// WEBPACK FOOTER //
// ./src/core/components/atomic/molecules/Avatar/index.js